import { useCallback, useState } from "react";

import { createError, parseGraphQLError } from "utils";

import { useAsyncCall, useRequest } from "hooks";
import createResolverFactory from "components/QueryClient/ResolverFactory";

const queryFactory = () => {
  const query = `query planFeatureAndPendingChanges {
          planFeatureEligibility(featureName: "conditional-next-workflows") {
            eligible
            cause
          }
          practice {
            pendingChanges
          }

        }`;

  const resolver = ({ data }) => {
    return {
      eligibility: data.planFeatureEligibility,
      pendingChanges: Boolean(data.practice?.pendingChanges),
    };
  };

  return { query: query, resolver: createResolverFactory(resolver) };
};

function useNextWorkflowConditionsEligibility() {
  const [call] = useAsyncCall();
  const { req } = useRequest(queryFactory);
  const [eligibilityMessage, setEligibilityMessage] = useState("");

  const getEligibilityMessage = useCallback(
    ({ eligibility, pendingChanges }) => {
      if (!eligibility?.eligible && pendingChanges) {
        return {
          title: "Pending Changes",
          content:
            "Please wait for the pending changes to be processed before you could access this feature.",
        };
      }

      return {
        title: "Upgrade to Enable Conditional Next Workflows",
        content: eligibility?.cause || "",
      };
    },
    []
  );

  return {
    eligibilityMessage: eligibilityMessage,
    checkEligibility: useCallback(() => {
      return call(async () => {
        try {
          const resp = await req();

          const message = getEligibilityMessage(resp);
          setEligibilityMessage(message);

          return !message?.content;
        } catch (e) {
          const err = createError({
            ...parseGraphQLError(e),
            name: "getPlanOption",
            defaultMessage:
              "Unexpected error occurred when trying to check for conditional next workflows eligibility.",
          });
          console.error(err);

          setEligibilityMessage({ title: "Error", content: err.message });
          return false;
        }
      });
    }, [req, getEligibilityMessage, call]),
  };
}

export default useNextWorkflowConditionsEligibility;
